// Kart Atama (satış sonrası kulüp girişi kartı bağlama) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.postSaleCardAssignment';

export const salesPostSaleCardAssignmentGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Satıştan sonra kart nasıl atanır?'),
  intro: t(`${G}.intro`, 'Kulüp girişi satışı tamamlanınca bu pencere açılır; satılan her giriş hakkı için bir kart (bileklik) okutup satışa bağlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kart okutma ve kart listesi'),
    footer: t(`${G}.regions.footer`, 'İptal / Kartı Ata'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Ödeme alındıktan sonra satıştaki giriş hizmetlerini kartlara bağlar. Üstteki bilgi kutusu kaç kart okutmanız gerektiğini yazar. Bu pencerede para tahsil edilmez; ödeme satışta alınmıştır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kartları okutun'),
      text: t(`${G}.s2.text`, 'Kartı okutun veya "Kart UID okutun veya girin" kutusuna yazıp Enter\'a ya da "Ekle"ye basın. Okutulan kartlar "Okutulan Kartlar (x/y)" listesinde görünür; beklenen sayıya ulaşınca kutu kapanır. Yanlış kartı çöp kutusu simgesiyle çıkarın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Aynı kart iki kez okutulamaz; beklenenden fazla kart okutulamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Hizmeti veya paketi eşleştirin'),
      text: t(`${G}.s3.text`, 'Her kart sırayla bir giriş hizmetine bağlanır; hizmet adı kartın altında yazar. Paketli satışlarda kartın altında bir liste çıkar: hangi bilekliğe hangi paketin ve ürün haklarının (🎁) gideceğini oradan seçin. Başka bir kartta olan paketi seçerseniz iki kart yer değiştirir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Aynı paket iki bilekliğe atanamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Depozitoyu kontrol edin'),
      text: t(`${G}.s4.text`, 'Depozito açıksa her kartın depozitosu kart tipine göre belirlenir (kart tipinde tutar yoksa ekranın varsayılan depozitosu). Tutar kartın yanında, toplamı altta "Toplam Deposito" olarak görünür. Depozito karta kaydedilir; kart teslim alınırken iade edilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Depozito POS ile ödendiyse müşteriyi uyarın: iade yalnız aynı banka/kredi kartıyla ve gün sonu yapılmadan alınabilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kartları atayın'),
      text: t(`${G}.s5.text`, '"N Kartı Ata" kartları satışa bağlar ve her kart için oturum açar (içeride kartla ürün alabilmek için gerekir). Başarılı olunca "N kart başarıyla atandı!" yazar ve pencere kapanır.'),
      tips: [
        t(`${G}.s5.tip1`, '"İptal" ile kapatırsanız kartlar bu satışa bağlanmaz.'),
      ],
    },
  ],
});
